import styles from "./seo-content.module.scss"

// `content` must be sanitized before it reaches here (see sanitizeSeoContent in getServerSideProps).
export const SEOContent = ({ content }) => {
  return (
    <>{content && <div className={`${styles.seoContent} u-mb32`} dangerouslySetInnerHTML={{ __html: content }} />}</>
  )
}
